/**
 * Mother's Day Landing Page - Multi-Product Cart Handler
 * 
 * Handles multi-variant cart additions and dynamic header offset calculation.
 * 
 * Cart Handler:
 * - Reads variant IDs from data-md-cart-variants attribute
 * - Posts to /cart/add.js with all variants at once
 * - Dispatches cart:refresh and cart:open events
 * - Shows loading state, error state, and re-enables button only on success
 * 
 * Dynamic Offset Calculator:
 * - Calculates header height and adjusts page margins via CSS variables
 * - Handles resize and load events
 * - Uses debounce and requestAnimationFrame for performance
 */
(function() {
  function parseVariantIds(raw) {
    return String(raw || '')
      .split(/[\s,]+/)
      .map(s => parseInt(s, 10))
      .filter(n => n > 0);
  }

  document.addEventListener('click', function(e) {
    const button = e.target.closest('.md-tier-cta');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    const variantIds = button.getAttribute('data-md-cart-variants');
    if (!variantIds) return;

    const ids = parseVariantIds(variantIds);
    if (!ids.length) return;

    e.preventDefault();
    
    const originalHTML = button.innerHTML;
    const wasPreviouslyDisabled = button.disabled;
    
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = '<span class="loading-spinner"></span>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: ids.map(id => ({ id, quantity: 1 }))
      })
    })
    .then(res => res.json().then(data => {
      if (!res.ok) {
        throw new Error(data.description || data.message || 'Could not add items to cart');
      }
      return data;
    }))
    .then(() => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      setTimeout(() => {
        button.classList.remove('is-loading');
        button.setAttribute('aria-busy', 'false');
        button.disabled = wasPreviouslyDisabled;
        button.innerHTML = originalHTML;
      }, 100);
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
      button.classList.remove('is-loading');
      button.setAttribute('aria-busy', 'false');
      button.innerHTML = 'Unavailable';
      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.disabled = wasPreviouslyDisabled;
      }, 2500);
    });
  });
})();

(function() {
  function debounce(fn, ms) {
    var t;
    return function() {
      clearTimeout(t);
      var args = arguments;
      var self = this;
      t = setTimeout(function() { fn.apply(self, args); }, ms);
    };
  }

  function headerBottomPx() {
    var groups = document.querySelectorAll('#PageContainer .shopify-section-group-header-group');
    var bottom = 0;
    for (var i = 0; i < groups.length; i++) {
      var b = groups[i].getBoundingClientRect().bottom;
      if (b > bottom) bottom = b;
    }
    return Math.round(bottom);
  }

  function syncMdPageOffsets() {
    var root = document.getElementById('md-page');
    var banner = root && root.querySelector('.md-sticky-banner');
    var md = root && root.querySelector('.md');
    if (!root || !banner || !md) return;

    banner.style.marginTop = '0';
    md.style.marginTop = '0';

    var headerBottom = headerBottomPx();
    root.style.setProperty('--md-header-height', headerBottom + 'px');

    var bannerOverlap = Math.max(0, Math.round(banner.getBoundingClientRect().top - headerBottom));

    root.style.setProperty('--md-banner-overlap', bannerOverlap + 'px');

    banner.style.marginTop = '';
    void banner.offsetHeight;

    var gapMd = md.getBoundingClientRect().top - banner.getBoundingClientRect().bottom;
    var mdOverlap = Math.max(0, Math.round(gapMd));

    root.style.setProperty('--md-body-overlap', mdOverlap + 'px');

    md.style.marginTop = '';
  }

  var root = document.getElementById('md-page');
  if (!root) return;

  var run = debounce(syncMdPageOffsets, 100);

  function scheduleSync() {
    syncMdPageOffsets();
    requestAnimationFrame(function() {
      requestAnimationFrame(syncMdPageOffsets);
    });
    setTimeout(syncMdPageOffsets, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }

  window.addEventListener('resize', run);

  window.addEventListener('scroll', function() {
    var h = headerBottomPx();
    if (h > 0) root.style.setProperty('--md-header-height', h + 'px');
  }, { passive: true });
})();
